export const JobCardContent = [
  {
    "name": "Customer",
    "dbName": "customer"
  },
  {
    "name": "Start Date",
    "dbName": "startDate"
  },
  {
    "name": "End Date",
    "dbName": "endDate"
  },
  {
    "name": "Job Target Leads",
    "dbName": "createdDate"
  },
  {
    "name": "Action",
    "dbName": "id"
  }
]